<div class="main-404">
  <app-header-section></app-header-section>

  Term & Policy

  <app-modal-menu></app-modal-menu>
</div>
